export const OUTCOME_TITLE_COPY = {
  pollSetOutcome: 'Poll Set Outcome',
  liveEventOutcome: 'Live Event Outcome',
  surveyOutcome: 'Survey Outcome',
};
